import { render, staticRenderFns } from "./ServerInternalError.vue?vue&type=template&id=6b33655e&"
import script from "./ServerInternalError.vue?vue&type=script&lang=js&"
export * from "./ServerInternalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports